import { render, staticRenderFns } from "./templateWorkflowDataList.vue?vue&type=template&id=2820c097&scoped=true"
import script from "./templateWorkflowDataList.vue?vue&type=script&lang=js"
export * from "./templateWorkflowDataList.vue?vue&type=script&lang=js"
import style0 from "./templateWorkflowDataList.vue?vue&type=style&index=0&id=2820c097&prod&scoped=true&lang=scss"
import style1 from "./templateWorkflowDataList.vue?vue&type=style&index=1&id=2820c097&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2820c097",
  null
  
)

export default component.exports